import React, { FC, PropsWithChildren, ReactElement } from 'react'
import Tooltip from 'react-tooltip-lite'

interface ElementWithTooltipProps extends PropsWithChildren {
    tooltipIsActive?: boolean;
    tooltipText?: string;
    className?: string;
}

const ElementWithTooltip: FC<ElementWithTooltipProps> = ({
    tooltipIsActive = false,
    tooltipText,
    children,
    className = '',
}): ReactElement => (
    <>
        {tooltipIsActive ? (
            // @ts-ignore
            <Tooltip
                className={`element-with-tooltip ${className}`}
                content={tooltipText}
                arrowSize={6}
                padding={7}
            >
                {children}
            </Tooltip>
        ) : (
            children
        )}
    </>
)

export default ElementWithTooltip
